<template>
  <input v-model="value" class="form-control" type="hidden">
</template>

<script>
import BaseVuexFormItem from '@/views/molecules/formItems/BaseVuexFormItem';

export default {
  name: "VuexHiddenFormItem",
  extends: BaseVuexFormItem,
  components: {},
}
</script>
